import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { QueryResource, QueryResourcesInfinite } from '@/lib/datx-jsonapi-react';
import { AlgoliaFilterItem } from '@/resources/AlgoliaFilterItem';

export const querySpeakersFiltersEventsInfinite = ({
  filters,
  pageSize = 16,
}): QueryResourcesInfinite<AlgoliaFilterItem> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }

    const pageNumber = pageIndex + 1;

    return [
      'algoliasearch/thin_profile_filters/filters/events',
      {
        filter: omitBy(filters, isNil),
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

type ConferenceFilterType = 'publishers' | 'subjects' | 'release_years';

export const queryEventFiltersInfinite = (
  filterType: ConferenceFilterType,
  { filters, pageSize = 16 }
): QueryResourcesInfinite<AlgoliaFilterItem> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }

    const pageNumber = pageIndex + 1;

    return [
      `algoliasearch/thin_event_filters/filters/${filterType}`,
      {
        filter: omitBy(filters, isNil),
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

export const queryPublishersFiltersInfinite = (
  filterType: ConferenceFilterType,
  { filters, pageSize = 16 }
): QueryResourcesInfinite<AlgoliaFilterItem> => {
  return (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData?.links?.next) {
      return null;
    }

    const pageNumber = pageIndex + 1;

    return [
      `algoliasearch/thin_conference_filters/filters/${filterType}`,
      {
        filter: omitBy(filters, isNil),
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

// TODO rename after all dynamic filters are finished
export const querySelectedSpeakersFilterEvent = (filters: Record<string, string>): QueryResource<AlgoliaFilterItem> => {
  return [
    'algoliasearch/thin_profile_filters',
    'selected_filter',
    {
      filter: omitBy(filters, isNil),
    },
  ];
};

export const querySelectedConferenceFilters = (
  filters: Record<string, string | Array<string>>
): QueryResource<AlgoliaFilterItem> => {
  return [
    'algoliasearch/thin_event_filters',
    'selected_filter',
    {
      filter: omitBy(filters, isNil),
    },
  ];
};

export const querySelectedPublisherFilters = (
  filters: Record<string, string | Array<string>>
): QueryResource<AlgoliaFilterItem> => {
  return [
    'algoliasearch/thin_conference_filters',
    'selected_filter',
    {
      filter: omitBy(filters, isNil),
    },
  ];
};
